
/* ---------------- HERO 3D ---------------- */
(function(){
  var c=document.getElementById('gl'); if(!window.THREE||!c) return;
  var mob=window.matchMedia('(max-width:900px)').matches;
  var red=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
  var sc=new THREE.Scene();
  sc.fog=new THREE.FogExp2(0x06070c,0.055);
  var cam=new THREE.PerspectiveCamera(48,innerWidth/innerHeight,.1,120); cam.position.z=13;
  var rd;
  try{ rd=new THREE.WebGLRenderer({canvas:c,antialias:!mob,alpha:true}); }catch(e){ return; }
  rd.setPixelRatio(Math.min(devicePixelRatio,mob?1.5:2));
  rd.setSize(innerWidth,innerHeight);

  var grp=new THREE.Group(); sc.add(grp);

  /* nucleo: icosaedro wireframe */
  var geo=new THREE.IcosahedronGeometry(3.1,mob?1:2);
  var core=new THREE.Mesh(geo,new THREE.MeshBasicMaterial({color:0x6ee7ff,wireframe:true,transparent:true,opacity:.28}));
  grp.add(core);
  var shell=new THREE.Mesh(new THREE.IcosahedronGeometry(3.05,1),
    new THREE.MeshBasicMaterial({color:0x0a0f1c,transparent:true,opacity:.55}));
  grp.add(shell);

  /* anelli orbitali */
  var rings=[];
  for(var i=0;i<3;i++){
    var r=new THREE.Mesh(new THREE.TorusGeometry(4.6+i*1.35,.008,3,140),
      new THREE.MeshBasicMaterial({color:i%2?0xa78bfa:0x6ee7ff,transparent:true,opacity:.4}));
    r.rotation.x=Math.PI/2.4+i*.42; r.rotation.y=i*.6; grp.add(r); rings.push(r);
  }

  /* campo di particelle */
  var N=mob?900:2600, pos=new Float32Array(N*3), col=new Float32Array(N*3);
  var cA=new THREE.Color(0x6ee7ff), cB=new THREE.Color(0xa78bfa);
  for(var j=0;j<N;j++){
    var rad=6+Math.random()*22, th=Math.random()*Math.PI*2, ph=Math.acos(2*Math.random()-1);
    pos[j*3]=rad*Math.sin(ph)*Math.cos(th);
    pos[j*3+1]=rad*Math.sin(ph)*Math.sin(th)*.62;
    pos[j*3+2]=rad*Math.cos(ph);
    var m=cA.clone().lerp(cB,Math.random());
    col[j*3]=m.r; col[j*3+1]=m.g; col[j*3+2]=m.b;
  }
  var pg=new THREE.BufferGeometry();
  pg.setAttribute('position',new THREE.BufferAttribute(pos,3));
  pg.setAttribute('color',new THREE.BufferAttribute(col,3));
  var pts=new THREE.Points(pg,new THREE.PointsMaterial({size:mob?.06:.045,vertexColors:true,transparent:true,opacity:.75,sizeAttenuation:true}));
  sc.add(pts);

  var mx=0,my=0,tx=0,ty=0,sy=0;
  if(!mob){ addEventListener('pointermove',function(e){ tx=(e.clientX/innerWidth-.5); ty=(e.clientY/innerHeight-.5); },{passive:true}); }
  addEventListener('scroll',function(){ sy=scrollY; },{passive:true});
  addEventListener('resize',function(){ cam.aspect=innerWidth/innerHeight; cam.updateProjectionMatrix(); rd.setSize(innerWidth,innerHeight); });

  var t=0, run=true;
  var hero=document.getElementById('hero');
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(en){ run=en[0].isIntersecting; },{threshold:.01}).observe(hero);
  }
  (function loop(){
    requestAnimationFrame(loop);
    if(!run) return;
    t+=red?0:.006;
    mx+=(tx-mx)*.05; my+=(ty-my)*.05;
    grp.rotation.y=t*.7+mx*.85; grp.rotation.x=Math.sin(t*.5)*.14+my*.5;
    grp.position.y=Math.sin(t*.9)*.22-sy*.0025;
    for(var k=0;k<rings.length;k++){ rings[k].rotation.z=t*(.4+k*.22)*(k%2?-1:1); }
    pts.rotation.y=-t*.16+mx*.24; pts.rotation.x=my*.16;
    cam.position.z=13+sy*.004;
    rd.render(sc,cam);
  })();
})();


/* ---------------- REVEAL ---------------- */
var io=new IntersectionObserver(function(es){
  es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
},{threshold:.12,rootMargin:'0px 0px -60px 0px'});
document.querySelectorAll('.rv').forEach(function(el,i){ el.style.transitionDelay=(i%3)*.07+'s'; io.observe(el); });

/* ---------------- NAV ---------------- */
var nav=document.getElementById('nav'), sticky=document.getElementById('sticky');
addEventListener('scroll',function(){
  nav.classList.toggle('solid',scrollY>40);
  sticky.classList.toggle('show',scrollY>innerHeight*.8);
},{passive:true});

/* ---------------- CONTATORI ---------------- */
function sepIt(n){ return String(n).replace(/\B(?=(\d{3})+(?!\d))/g,'.'); }
function fmt(n,sep){ return sep? sepIt(n) : String(n); }
var cio=new IntersectionObserver(function(es){
  es.forEach(function(e){
    if(!e.isIntersecting) return; cio.unobserve(e.target);
    var el=e.target, to=+el.dataset.count, pre=el.dataset.prefix||'', suf=el.dataset.suffix||'', sep=!!el.dataset.sep;
    var big=to>=100000, t0=performance.now(), dur=1600;
    (function step(t){
      var p=Math.min((t-t0)/dur,1), e2=1-Math.pow(1-p,3), v=Math.round(to*e2);
      el.textContent=pre+(big?(v/1000000).toFixed(1).replace('.',',')+' mln':fmt(v,sep))+suf;
      if(p<1) requestAnimationFrame(step);
    })(t0);
  });
},{threshold:.5});
document.querySelectorAll('[data-count]').forEach(function(el){ cio.observe(el); });

/* ---------------- CHART 1 : domanda ---------------- */
(function(){
  var svg=document.getElementById('chart1'); if(!svg) return;
  var W=580,H=230,PT=18,PB=16,MAX=760;
  var years=['2019','2020','2021','2022','2023','2024','2025','2026'];
  var d3d=[100,118,164,232,318,430,540,680], dtr=[100,104,101,96,92,88,84,80];
  document.getElementById('yrs').innerHTML=years.map(function(y){return '<span>'+y+'</span>';}).join('');
  function pt(v,i,n){ return [ (i/(n-1))*W, H-PB-(v/MAX)*(H-PT-PB) ]; }
  function path(a){
    var p=a.map(function(v,i){return pt(v,i,a.length);}), d='M'+p[0][0]+','+p[0][1];
    for(var i=0;i<p.length-1;i++){
      var c=(p[i][0]+p[i+1][0])/2;
      d+=' C'+c+','+p[i][1]+' '+c+','+p[i+1][1]+' '+p[i+1][0]+','+p[i+1][1];
    }
    return {d:d,p:p};
  }
  var A=path(d3d), B=path(dtr);
  var ns='http://www.w3.org/2000/svg';
  svg.innerHTML=
   '<defs>'+
   '<linearGradient id="ga" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#6ee7ff" stop-opacity=".35"/><stop offset="1" stop-color="#6ee7ff" stop-opacity="0"/></linearGradient>'+
   '<linearGradient id="gs" x1="0" y1="0" x2="1" y2="0"><stop offset="0" stop-color="#6ee7ff"/><stop offset="1" stop-color="#a78bfa"/></linearGradient>'+
   '</defs>'+
   [1,2,3].map(function(i){ var y=PT+(H-PT-PB)*i/4; return '<line x1="0" y1="'+y+'" x2="'+W+'" y2="'+y+'" stroke="rgba(255,255,255,.055)" stroke-width="1"/>'; }).join('')+
   '<line x1="0" y1="'+(H-PB)+'" x2="'+W+'" y2="'+(H-PB)+'" stroke="rgba(255,255,255,.13)" stroke-width="1"/>'+
   '<path d="'+B.d+'" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="2" stroke-dasharray="5 5"/>'+
   '<path id="c1a" d="'+A.d+' L'+W+','+(H-PB)+' L0,'+(H-PB)+' Z" fill="url(#ga)" opacity="0"/>'+
   '<path id="c1l" class="gl" d="'+A.d+'" fill="none" stroke="url(#gs)" stroke-width="2.6" stroke-linecap="round"/>'+
   A.p.map(function(q,i){ return '<circle cx="'+q[0]+'" cy="'+q[1]+'" r="'+(i===A.p.length-1?5:3)+'" fill="'+(i===A.p.length-1?'#a78bfa':'#6ee7ff')+'" opacity="0" class="c1d" style="transition:opacity .4s '+(.6+i*.09)+'s"/>'; }).join('');
  var line=svg.querySelector('#c1l'), L=line.getTotalLength();
  line.style.strokeDasharray=L; line.style.strokeDashoffset=L;
  new IntersectionObserver(function(es,o){
    if(!es[0].isIntersecting) return; o.disconnect();
    line.style.transition='stroke-dashoffset 1.9s cubic-bezier(.16,1,.3,1)'; line.style.strokeDashoffset=0;
    var ar=svg.querySelector('#c1a'); ar.style.transition='opacity 1.4s .5s'; ar.style.opacity=1;
    svg.querySelectorAll('.c1d').forEach(function(d){ d.style.opacity=1; });
  },{threshold:.3}).observe(svg);
})();

/* ---------------- CHART 2 : donut ---------------- */
(function(){
  var svg=document.getElementById('chart2'); if(!svg) return;
  var R=72,C=2*Math.PI*R,pct=.4;
  svg.innerHTML='<defs><linearGradient id="gd" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stop-color="#a78bfa"/><stop offset="1" stop-color="#6ee7ff"/></linearGradient></defs>'+
   '<circle cx="100" cy="100" r="'+R+'" fill="none" stroke="rgba(255,255,255,.09)" stroke-width="20"/>'+
   '<circle id="c2a" cx="100" cy="100" r="'+R+'" fill="none" stroke="url(#gd)" stroke-width="20" stroke-linecap="round" transform="rotate(-90 100 100)" stroke-dasharray="'+C+'" stroke-dashoffset="'+C+'"/>'+
   '<text x="100" y="94" text-anchor="middle" fill="#f4f6fb" font-family="Space Grotesk" font-size="38" font-weight="700">40%</text>'+
   '<text x="100" y="118" text-anchor="middle" fill="rgba(244,246,251,.5)" font-family="Inter" font-size="13">senza sito</text>';
  new IntersectionObserver(function(es,o){
    if(!es[0].isIntersecting) return; o.disconnect();
    var a=svg.querySelector('#c2a');
    a.style.transition='stroke-dashoffset 1.8s cubic-bezier(.16,1,.3,1)';
    a.style.strokeDashoffset=C*(1-pct);
  },{threshold:.4}).observe(svg);
})();

/* ---------------- CHART 3 : fasce di prezzo ---------------- */
(function(){
  var box=document.getElementById('chart3'); if(!box) return;
  var MAX=12000;
  var data=[
    {l:'Sito vetrina da template',min:400,max:900},
    {l:'Sito su misura (2D)',min:1200,max:2500},
    {l:'Sito 3D / interattivo',min:2500,max:6000,hi:1},
    {l:'Configuratore prodotto 3D',min:4000,max:12000,hi:1}
  ];
  var eur=function(n){ return '€'+sepIt(n); };
  box.innerHTML=data.map(function(d){
    return '<div class="bar'+(d.hi?' hi':'')+'"><div class="bl"><b>'+d.l+'</b><span>'+eur(d.min)+' – '+eur(d.max)+'</span></div>'+
    '<div class="track"><div class="fill" data-l="'+(d.min/MAX*100)+'" data-w="'+((d.max-d.min)/MAX*100)+'" style="left:'+(d.min/MAX*100)+'%;background:'+(d.hi?'linear-gradient(90deg,#6ee7ff,#a78bfa)':'rgba(255,255,255,.24)')+(d.hi?';box-shadow:0 0 18px -2px rgba(110,231,255,.6)':'')+'"></div></div></div>';
  }).join('')+'<div class="scale"><span>€0</span><span>€6.000</span><span>€12.000</span></div>';
  new IntersectionObserver(function(es,o){
    if(!es[0].isIntersecting) return; o.disconnect();
    box.querySelectorAll('.fill').forEach(function(f,i){
      setTimeout(function(){ f.style.width=f.dataset.w+'%'; }, 120*i);
    });
  },{threshold:.3}).observe(box);
})();

/* ---------------- ACCORDION MODULI + FAQ ---------------- */
function acc(sel,head,body,cls){
  document.querySelectorAll(sel).forEach(function(it){
    it.querySelector(head).addEventListener('click',function(){
      var open=it.classList.contains(cls);
      document.querySelectorAll(sel+'.'+cls).forEach(function(o){
        o.classList.remove(cls); o.querySelector(body).style.maxHeight=0;
      });
      if(!open){ it.classList.add(cls); var b=it.querySelector(body); b.style.maxHeight=b.scrollHeight+'px'; }
    });
  });
}
acc('.mod','.modh','.modb','open');
acc('.fq','.fqh','.fqb','open');
document.querySelector('.mod').classList.add('open');
document.querySelector('.mod .modb').style.maxHeight=document.querySelector('.mod .modb').scrollHeight+'px';
addEventListener('resize',function(){
  document.querySelectorAll('.mod.open .modb,.fq.open .fqb').forEach(function(b){ b.style.maxHeight=b.scrollHeight+'px'; });
});

/* ---------------- ROI ---------------- */
(function(){
  var s1=document.getElementById('s1'),s2=document.getElementById('s2'),s3=document.getElementById('s3');
  if(!s1) return;
  var out=document.getElementById('rout'), rec=document.getElementById('rrec');
  function upd(){
    var n=+s1.value, p=+s2.value, m=+s3.value;
    document.getElementById('r1').textContent=n;
    document.getElementById('r2').textContent=sepIt(p);
    document.getElementById('r3').textContent=m;
    var recur=m*120*12, tot=n*p*12+recur;
    out.textContent='€'+sepIt(tot);
    rec.textContent='€'+sepIt(recur);
  }
  [s1,s2,s3].forEach(function(s){ s.addEventListener('input',upd); });
  upd();
})();

/* ---------------- TILT CARDS (desktop) ---------------- */
if(!window.matchMedia('(max-width:900px)').matches && !window.matchMedia('(prefers-reduced-motion:reduce)').matches){
  document.querySelectorAll('.tilt').forEach(function(el){
    el.addEventListener('pointermove',function(e){
      var r=el.getBoundingClientRect();
      var x=(e.clientX-r.left)/r.width-.5, y=(e.clientY-r.top)/r.height-.5;
      el.style.transform='perspective(900px) rotateY('+(x*7)+'deg) rotateX('+(-y*7)+'deg) translateY(-6px)';
    });
    el.addEventListener('pointerleave',function(){ el.style.transform=''; });
  });
}

/* Offerta a tempo: un'ora piena per ogni visitatore, dal suo primo ingresso.
   La scadenza resta in localStorage, cosi' ricaricando la pagina il conto
   non riparte da capo; chi torna dopo la scadenza trova una nuova ora. */
(function () {
  var KEY = "p3dOfferEnd", HOUR = 3600000;
  function read() { try { return +localStorage.getItem(KEY) || 0; } catch (e) { return 0; } }
  function save(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  var end = read(), now = Date.now();
  if (!end || end <= now || end - now > HOUR) { end = now + HOUR; save(end); }

  var els = document.querySelectorAll("[data-p3d-cd]");
  if (!els.length) return;
  function two(n) { return n < 10 ? "0" + n : "" + n; }
  function fmt(ms) {
    var s = Math.max(0, Math.round(ms / 1000));
    return Math.floor(s / 3600) + ":" + two(Math.floor(s % 3600 / 60)) + ":" + two(s % 60);
  }
  var id = setInterval(tick, 1000);
  function tick() {
    var left = end - Date.now(), txt = fmt(left);
    for (var i = 0; i < els.length; i++) els[i].textContent = txt;
    if (left <= 0) clearInterval(id);
  }
  tick();
})();
